import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  Layout
} from './components';
import { LocaleProvider } from './context';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <LocaleProvider>
        <Layout>
          <App />
        </Layout>
      </LocaleProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
